import React from "react";
import axios from "axios";
import Accordion from "../../../../components/Accordion/Accordion";
import GridContainer from "../../../../components/Grid/GridContainer";
import GridItem from "../../../../components/Grid/GridItem";
import Button from "../../../../components/CustomButtons/Button";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import CustomPagination from "../../../../components/Table2/CustomPagination";
import { format } from "date-fns";

class VoucherLog extends React.Component {
  state = {
    showVoucherLog: false,
    voucherLogs: [],
    current_page: 1,
    nextPageCursor: null,
    prevPageCursor: null,
  };

  toggleVoucherLog = () => {
    if (this.state.showVoucherLog === false) {
      this.loadVoucherLog();
    }

    this.setState({ showVoucherLog: !this.state.showVoucherLog });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const needsRefreshData = ["per_page", "current_page"];
    let refreshData = false;
    needsRefreshData.forEach((item) => {
      if (this.state[item] !== prevState[item]) {
        refreshData = true;
      }
    });
    if (refreshData) {
      this.loadApiLog();
    }
  }

  loadVoucherLog = () => {
    const params = [
      {
        field: "bestelling_id",
        operator: "=",
        value: this.props.bestellingId,
      },
    ];
    let url = "core/voucherlog/search?sort_field=id&sort_dir=desc&per_page=250";
    if (this.state.cursor) {
      url += "&cursor=" + this.state.cursor;
    }

    axios.post(url, params).then((response) => {
      let nextPageCursor;
      if (response.data.data.next_page_url) {
        const next_page = new URL(response.data.data.next_page_url);
        nextPageCursor = next_page.searchParams.get("cursor");
      }
      let prevPageCursor;
      if (response.data.data.prev_page_url) {
        const prev_page = new URL(response.data.data.prev_page_url);
        prevPageCursor = prev_page.searchParams.get("cursor");
      }

      if (prevPageCursor && this.state.current_page === 1) {
        this.setState({ current_page: 2 });
      } else if (response.data.data.total == null && !prevPageCursor && this.state.current_page > 1) {
        this.setState({ current_page: 1 });
      }

      this.setState({
        nextPageCursor,
        prevPageCursor,
        total_items: null,
        total_pages: null,
        loading: false,
      });

      this.setState({
        voucherLogs: response.data.data.data,
      });
    });
  };

  handlePagination = (page, next) => {
    // if (Object.keys(this.props.filters).length === 0) {
    //   this.setState({ last_page_before_filtering: page });
    // }

    let cursor = null;
    if (next === "next") {
      cursor = this.state.nextPageCursor;
    } else {
      cursor = this.state.prevPageCursor;
    }
    this.setState({ cursor });
    this.setState({ current_page: page });
  };

  render() {
    const accordionData = this.state.voucherLogs.map((voucherLog, key) => {
      const apiLogDataFormated = format(new Date(voucherLog.ts * 1000), "dd-MM-yyyy HH:mm:ss");

      const title =
        apiLogDataFormated +
        " --- " +
        voucherLog.eventStage +
        " --- " +
        voucherLog.discountType +
        " (" +
        voucherLog.voucherPrice +
        ")" +
        " --- " +
        voucherLog.vouchercode +
        " --- " +
        voucherLog.resultmsg;

      return {
        title: title,
        content: (
          <textarea
            defaultValue={JSON.stringify(JSON.parse(voucherLog.voucherData), null, 2)}
            style={{
              width: "100%",
              height: "400px",
            }}
          />
        ),
      };
    });

    return (
      <div>
        <GridContainer>
          <GridItem>
            <Button color={"info"} onClick={this.toggleVoucherLog}>
              <TranslationWrapper
                tDefault={"Show Voucher Log"}
                tKey={"bestellingen.modal.detail.apilog.toggleVoucherLog"}
              />
            </Button>
          </GridItem>
        </GridContainer>

        <GridContainer>{this.state.showVoucherLog ? <Accordion collapses={accordionData} /> : null}</GridContainer>

        {this.state.showVoucherLog && (this.state.nextPageCursor || this.state.prevPageCursor) ? (
          <CustomPagination
            current_page={this.state.current_page}
            nextPageCursor={this.state.nextPageCursor}
            onClick={this.handlePagination}
            prevPageCursor={this.state.prevPageCursor}
            total_pages={undefined}
          />
        ) : null}
      </div>
    );
  }
}

export default VoucherLog;
